import { useState } from 'react';
import { MinimalEmoji, StreamMessage, useEmojiContext } from 'stream-chat-react';
import type { BaseEmoji } from 'emoji-mart';
import type { NimbleEmojiProps } from 'emoji-mart';
import { makeStyles } from '@material-ui/styles';
import { getUsersByReaction } from '../../utils/reactions';
import { Channel } from 'stream-chat';
import CustomReactionItem from './CustomReactionItem';

type ReactionEmoji = BaseEmoji | MinimalEmoji;

interface CustomReactionsListProps {
    additionalEmoji?: Partial<NimbleEmojiProps>;
    reactionCounts: Record<string, number>;
    reactionOptions?: ReactionEmoji[];
    ownReactionTypes?: string[];
    onReactionClick?: (reactionType, event) => void;
    channel: Channel;
    message: StreamMessage;
}
const CustomReactionsList: React.FC<CustomReactionsListProps> = ({
    reactionOptions: propReactionOptions,
    additionalEmoji = {},
    reactionCounts = {},
    ownReactionTypes = [],
    onReactionClick = () => null,
    channel,
    message,
}) => {
    const classes = useStyles();
    const { emojiConfig } = useEmojiContext();

    const [reactionUsersMap, setReactionUsersMap] = useState({});

    const { defaultMinimalEmojis } = emojiConfig || {};

    const reactionOptions = propReactionOptions || defaultMinimalEmojis;

    const getCurrentMessageReactionTypes = () => reactionCounts && Object.keys(reactionCounts);

    const messageReactionTypes = getCurrentMessageReactionTypes();

    if (!messageReactionTypes?.length) {
        return null;
    }

    const getEmojiByReactionType = (type: string): ReactionEmoji | undefined => {
        return reactionOptions.find((option: ReactionEmoji) => option.id === type);
    };

    const fetchReactionUsers = async () => {
        const map = await getUsersByReaction(channel, message.id);
        setReactionUsersMap(map);
    };

    return (
        <ul className={classes.reactionsList} onMouseEnter={() => fetchReactionUsers()}>
            {messageReactionTypes.map(reactionType => {
                const emojiObject = getEmojiByReactionType(reactionType);

                return (
                    <CustomReactionItem
                        key={emojiObject.id}
                        reactionType={reactionType}
                        propReactionOptions={propReactionOptions}
                        reactionUsersMap={reactionUsersMap}
                        additionalEmoji={additionalEmoji}
                        reactionCounts={reactionCounts}
                        ownReactionTypes={ownReactionTypes}
                        onReactionClick={onReactionClick}
                    />
                );
            })}
        </ul>
    );
};

const useStyles = makeStyles(
    () => ({
        reactionsList: {
            display: 'flex',
            listStyle: 'none',
            border: 'none',
            padding: 0,
            margin: 0,
        },
    }),
    { classNamePrefix: 'custom-reaction-list' }
);

export default CustomReactionsList;
